import { render, staticRenderFns } from "./teeth.vue?vue&type=template&id=2da6e012&"
import script from "./teeth.vue?vue&type=script&lang=js&"
export * from "./teeth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports